// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cluster-count-info[data-v-5762c5a0]{display:flex;align-items:center}.cluster-count-info i[data-v-5762c5a0]{margin-left:5px;font-size:22px;color:var(--warning)}", ""]);
// Exports
module.exports = exports;
